import createTheme from '@mui/material/styles/createTheme';

import typography from './typography';
import { lightColors, darkColors } from './colors';

export const themeLight = createTheme(
  {
    palette: {
      background: {
        default: '#f9fafb',
        paper: '#fff',
      },
      text: {
        primary: '#24262d',
        secondary: '#4c4f52',
      },
    },
    spacing: 4,
    typography,
  },
  {
    ...lightColors,
  }
);

export const themeDark = createTheme(
  {
    palette: {
      background: {
        default: '#121317',
        paper: '#1a1c23',
      },
      text: {
        primary: '#e5e7eb',
        secondary: '#d5d6d7',
      },
    },
    spacing: 4,
    typography,
  },
  {
    ...darkColors,
  }
);
